import React, { useEffect } from "react";
import { Footer } from "./Footer";
import { useDispatch, useSelector } from "react-redux";
import { baseURL } from "../../constants/baseURL";
import { Loader } from "../minor-components/Loader";
import { getBlogs } from "../../redux/Actions/BlogsActions";

export const Blogs = () => {
    const dispatch = useDispatch();
    const loading = useSelector((state) => state.ProgressBarReducer);
    const { blogs } = useSelector((state) => state.blogReducer);

    useEffect(() => {
        dispatch(getBlogs());
    }, [dispatch]);

    return (
        <>
            {!loading ? (
                <>
                    <section className="relative py-20 overflow-hidden">
                        <div className="relative container px-4 mx-auto">
                            <div className="max-w-2xl mx-auto mb-15 text-center">
                                <h1 className="text-3xl lg:text-4xl font-bold leading-9 text-gray-800 mb-8">
                                    Latest From The Blog
                                </h1>
                            </div>
                            <div className="max-w-7xl mx-auto">
                                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                                    {blogs?.map((blog, index) => (
                                        <div key={blog?._id || index} className="h-full">
                                            <div className="bg-white h-full shadow-lg hover:shadow-xl transition-shadow duration-300 border border-gray-200 rounded-2xl overflow-hidden">
                                                <a href={`/blog/${blog?._id}`} className="block">
                                                    <img 
                                                        className="w-full h-56 object-cover" 
                                                        src={blog?.blogImage ? baseURL + blog?.blogImage : "https://flowbite.com/docs/images/blog/image-1.jpg"} 
                                                        alt={blog?.blogHeading || "Blog image"} 
                                                    />
                                                </a>
                                                <div className="p-6">
                                                    <a href={`/blog/${blog?._id}`} className="block mb-4">
                                                        <h2 
                                                            className="text-xl font-bold text-gray-900 line-clamp-2 mb-2"
                                                            dangerouslySetInnerHTML={{ 
                                                                __html: blog?.blogHeading || '' 
                                                            }}
                                                        />
                                                    </a>
                                                    <div 
                                                        className="text-gray-600 line-clamp-3 mb-4"
                                                        dangerouslySetInnerHTML={{ 
                                                            __html: blog?.data ? blog?.data.slice(0, 150) + '...' : '' 
                                                        }}
                                                    />
                                                    <div className="flex justify-center">
                                                        <a 
                                                            href={`/blog/${blog?._id}`}
                                                            className="inline-block px-6 py-2.5 bg-[#3e0d31] text-white font-medium rounded-full text-sm hover:bg-[#2a0921] transition-colors duration-300"
                                                        >
                                                            Read more
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </section>
                    <Footer />
                </>
            ) : (
                <Loader />
            )}
        </>
    );
};